import {ComponentProps} from "react";
import Styles from "./index.module.css";


function Divider(props: ComponentProps<any>) {
    const {children} = props
    return (
        <span className={Styles.container}>
            {children}
        </span>
    )
}

export default Divider
